
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/merchant",
      function () {
        return require("private-next-pages/search/merchant/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/merchant"])
      });
    }
  